import { render } from "./CollectionLinks.vue?vue&type=template&id=11fc0068"
import script from "./CollectionLinks.vue?vue&type=script&lang=js"
export * from "./CollectionLinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__